import { ROUTES } from "routes/constants";
import { CalendlyLink, githubLink } from "constants/Links";

export const PlanData = {
  usage: ["Apps", "Storage Volumes", "Seats"],
  features: ["Web Dashboard", "SSO", "Hosted on Your Domain"],
  support: [
    "Community Support",
    "Private Slack Channel",
    "Dedicated Engineering Support",
    "Priority SLA",
    "Activation & Training"
  ],
  plans: [
    {
      type: "Community Edition",
      price: "Free to Self-Host",
      usage: ["Unlimited", "Unlimited", "Unlimited"],
      features: [false, false, false, false, true, true, false],
      support: [true, false, false, false, false],
      getStartedUrl: githubLink,
      primary: true
    },
    {
      type: "Enterprise",
      price: "Custom Pricing",
      usage: ["Unlimited", "Unlimited", "Unlimited"],
      features: [true, true, true, true, true, true, true],
      support: [true, true, true, true, true],
      getStartedUrl: CalendlyLink
    }
  ]
};
